function _isTrue(val) {
    return val === "true";
}
const INTERCOM_URL = "https://widget.intercom.io/widget/";
const INTERCOM_SETTINGS = {
    disabled: _isTrue("false"),
    app_id: "cs5cnmip",
    hide_default_launcher: _isTrue("false"),
    alignment: "right",
    horizontal_padding: Number.parseInt("20"),
    vertical_padding: Number.parseInt("20"),
    enable_mobile_padding: _isTrue("false"),
    language_override: undefined,
};
const injectScript = (settings) => {
    const headOrBody = document.head || document.body;
    if (settings.enable_mobile_padding) {
        const style = document.createElement("style");
        style.innerHTML = `#intercom-container iframe[name=intercom-chat-frame]{bottom:${settings.vertical_padding}px!important}`;
        headOrBody.appendChild(style);
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `${INTERCOM_URL}${settings.app_id}`;
    headOrBody.appendChild(script);
    return script;
};
const loadScript = (settings) => {
    return new Promise((resolve, reject) => {
        if (typeof window.intercomSettings === "undefined") {
            window.intercomSettings = settings;
        }
        try {
            const i = function (...args) {
                i.c(args);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            window.Intercom = i;
            if (settings.disabled)
                return window.Intercom;
            let script = injectScript(settings);
            script.addEventListener("load", () => {
                window.Intercom("boot", settings);
                resolve(window.Intercom);
            }, false);
        }
        catch (error) {
            reject(error);
            return;
        }
    });
};
export async function getIntercomInstance(command, ...args) {
    let instance = window.Intercom;
    if (!instance) {
        if (_isTrue("false")) {
            INTERCOM_SETTINGS.language_override = window.$nuxt.$i18n.locale;
        }
        instance = await loadScript(INTERCOM_SETTINGS);
    }
    return command ? instance(command, ...args) : instance;
}
const intercomPlugin = (ctx, inject) => {
    inject("intercom", getIntercomInstance);
};
export default intercomPlugin;
//# sourceMappingURL=plugin.js.map